// ABOUTME: RTK Query endpoints for the cross-customer software orders overview.
// ABOUTME: Calls the warehouse-api all-customers order-history endpoint (SHA only).

import { apiSlice } from "../createApiSlice";

export const softwareOrdersSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllCustomersOrderHistory: builder.query({
            query: ({ range, year, month }) => {
                const params = new URLSearchParams();
                params.set('range', range);
                if (range === 'month') {
                    params.set('year', String(year));
                    params.set('month', String(month));
                }
                return {
                    url: `/reports/dashboard/orderhistory/all-customers?${params.toString()}`,
                    method: 'GET',
                };
            },
            providesTags: () => [{ type: 'SoftwareOrders' }],
        }),
    }),
});

export const { useGetAllCustomersOrderHistoryQuery } = softwareOrdersSlice;
